import type { ReactNode } from 'react';

export type ToastVariant = 'default' | 'destructive' | 'success';

type ToastIdentityInput = {
  description?: ReactNode;
  title?: ReactNode;
  variant: ToastVariant;
};

function normalizeToastPart(value: ReactNode): null | string | undefined {
  if (value === false || value === null || value === undefined) {
    return undefined;
  }

  if (typeof value === 'bigint' || typeof value === 'number') {
    return String(value);
  }

  if (typeof value !== 'string') {
    return null;
  }

  const normalizedValue = value.replace(/\s+/g, ' ').trim();

  return normalizedValue || undefined;
}

export function resolveToastId(params: ToastIdentityInput): string | undefined {
  const { description, title, variant } = params;
  const normalizedDescription = normalizeToastPart(description);
  const normalizedTitle = normalizeToastPart(title);

  if (normalizedDescription === null || normalizedTitle === null) {
    return undefined;
  }

  if (!normalizedDescription && !normalizedTitle) {
    return undefined;
  }

  return [
    variant,
    normalizedTitle && `title:${normalizedTitle}`,
    normalizedDescription && `description:${normalizedDescription}`,
  ]
    .filter((value): value is string => Boolean(value))
    .join('|');
}
